import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IntlMessages from '../../components/IntlMessage';
import {
  Button,
  Card,
  Table,
  Modal,
  Row,
  Col,
  Space,
  Typography,
  message,
  Image,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import orderApi from '../../api/order';
// import moment from 'moment';
import Currency from '../../components/Currency';
import FilterBar from '../../components/FilterBar';
import customersApi from '../../api/customers';
import FormSearch from './Formsearch';
import FormPax from './FormPax';
import EditOrderForm from './edit/EditOrderForm';
import { useDispatch } from 'react-redux';
import { updateEditOrderValues } from '../../redux/actions/EditOrderAction';
import FormPdf from './formPDF';
import Status from '../../components/Status';
import { Link } from 'react-router-dom';
import { LocalStorageKeys, OrderStatus, PayStatus } from '../../utils/constant';
import useStatus from '../../hooks/useStatus';
import {
  ClockCircleOutlined,
  CopyOutlined,
  DownloadOutlined,
  EnvironmentOutlined,
  FieldTimeOutlined,
  PushpinOutlined,
} from '@ant-design/icons';
import CustomerDetails from './customer/CustomerDetails';
// import hopsApi from '../../api/hops';
// import routesApi from '../../api/route';
import tourApi from '../../api/tour';
import useTime from '../../hooks/useTime';
import dayjs from 'dayjs';
import { getWithExpiry, setWithExpiry } from '../../utils/localStorage';
import PickupModal from './PickupModal';
import operatorsApi from '../../api/operators';
import DropOffModal from './DropOffModal';
import zalo_icon from '../../assets/img/zalo_icon.png';
import AssignOperatorModal from './AssignOperatorModal';
import ModalSupplierStatus from './ModalSupplierStatus';

Orders.propTypes = {
  items: PropTypes.array,
};
Orders.defaultProps = {
  items: [],
};
// id: "0" => false, 1: true

const { Text, Paragraph } = Typography;

function Orders(props) {
  const storage = getWithExpiry(LocalStorageKeys.order_list);
  const dispatch = useDispatch();
  const isMount = useRef(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});
  const [filter, setFilter] = useState(
    storage && storage?.filter
      ? storage.filter
      : {
          page: 1,
          limit: 10,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        }
  );
  // const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const { orderStatusFilter, payStatusFilter } = useStatus();
  const [modalPDF, setModalPDF] = useState(false);
  const [modalCus, setModalCus] = useState(false);
  const [customers, setCustomers] = useState([]);
  const { convertToAnyTimezone } = useTime();
  const [pickupModal, setPickupModal] = useState(false);
  const [dropOffModal, setDropOffModal] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [modalUpload, setModalUpload] = useState(false);

  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        setLoading(true);
        let items = await orderApi.getAll(filter);

        setItems(items.data);
        setLoading(false);
        // setDeleting(false);
        if (total !== items.total) setTotal(items.total);
      }
    }
    fetchData();

    return () => {
      isMount.current = false;
    };
  }, [filter, reload]);

  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        };
        let cat = await customersApi.getAll(filter);
        cat.data.length > 0 &&
          cat.data.map((item) => {
            item.title = `${item.fullname}${
              item.company_shortname ? ` (${item.company_shortname})` : ''
            }`;
          });
        setCustomers(cat.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const [operators, setOperators] = useState([]);
  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        var filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        };
        let cat = await operatorsApi.getAll(filter);
        cat.data.length > 0 &&
          cat.data.map((item) => {
            item.title = `${item.title}`;
          });
        setOperators(cat.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const [tours, setTours] = useState([]);
  // side effects
  useEffect(() => {
    isMount.current = true;
    if (isMount) {
      let filter = {
        page: 1,
        limit: 1000,
        keyword: '',
        order_by: 'id',
        order_dir: 'DESC',
      };
      Promise.all([tourApi.getAll(filter)])
        .then((data) => {
          let toursData = data[0]?.data;
          if (Array.isArray(toursData)) {
            toursData = toursData
              // .filter((route) => route?.hops?.length > 0)
              .map((tour) => ({
                title: `${tour?.title} (${
                  tour?.operator && tour?.operator?.title
                })`,
                id: JSON.stringify(tour.id) || [],
              }));
            setTours(toursData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    return () => {
      isMount.current = false;
    };
  }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
    setWithExpiry(LocalStorageKeys.order_list, {
      filter: {
        ...filter,
        page: pagination.current,
        limit: pagination.pageSize,
        order_dir: getOrder(sorter.order),
        order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
      },
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
      setWithExpiry(LocalStorageKeys.order_list, {
        filter: { ...filter, keyword: value, page: 1 },
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
      setWithExpiry(LocalStorageKeys.order_list, {
        filter: {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        },
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  // const onOpenModal = (record = null) => {
  //   setItem(record);
  //   console.log(record);
  //   setModal(true);
  // };
  // const onCloseModal = () => {
  //   setModal(false);
  // };

  const onOpenEditModal = async (record = null) => {
    // console.log(record);
    setItem(record);
    const departureCabins = record?.hop?.cabins;
    const departureAddons = record?.hop?.addons;

    const departure = { cabins: [], addons: [] };
    if (Array.isArray(departureCabins)) {
      departure.cabins = departureCabins.map((cabin) => ({
        hop_id: record?.hop?.id,
        cabin_id: cabin?.cabin?.id,
        title: cabin?.cabin?.title,
        price: cabin?.price,
        quantity: cabin?.qty,
      }));
    }
    if (Array.isArray(departureAddons)) {
      departure.addons = departureAddons.map((addon) => ({
        hop_id: record?.hop?.id,
        addon_id: addon?.addon?.id,
        title: addon?.addon?.title,
        price: addon?.price,
        quantity: addon?.qty,
        notes: addon?.notes,
      }));
    }

    const returnCabins = record?.return_hop?.cabins;
    const returnAddons = record?.return_hop?.addons;

    const returnValues = { cabins: [], addons: [] };
    if (record?.roundtrip) {
      if (Array.isArray(returnCabins)) {
        returnValues.cabins = returnCabins.map((cabin) => ({
          hop_id: record?.return_hop?.id,
          cabin_id: cabin?.cabin?.id,
          title: cabin?.cabin?.title,
          price: cabin?.price,
          quantity: cabin?.qty,
        }));
      }
      if (Array.isArray(returnAddons)) {
        returnValues.addons = returnAddons.map((addon) => ({
          hop_id: record?.return_hop?.id,
          addon_id: addon?.addon?.id,
          title: addon?.addon?.title,
          price: addon?.price,
          quantity: addon?.qty,
          notes: addon?.notes,
        }));
      }
    }
    dispatch(updateEditOrderValues({ departure, return: returnValues }));
    setEditModal(true);
  };

  const onCloseEditModal = () => {
    setEditModal(false);
  };

  const [modalPax, setModalPax] = useState(false);
  const onOpenModalPax = (record = null) => {
    setModalPax(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModalPax = () => {
    setModalPax(false);
  };
  // console.log('item', items);
  const intl = useIntl();

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await orderApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    // setDeleting(true);
    onReload();
  };

  const handleUpdateStatus = async (record, status) => {
    const data = {
      order_status: status,
    };
    setLoading(true);
    Modal.confirm({
      title:
        status === OrderStatus.cancelled.status
          ? intl.formatMessage({ id: 'global.order_cancel' })
          : intl.formatMessage({ id: 'global.order_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await orderApi
          .updateStatus(record.id, data)
          .then(() => {
            setLoading(false);
            onReload();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      },
      onCancel() {},
    });

    setLoading(false);
  };

  const onOpenModalPDF = (record = null) => {
    setModalPDF(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModalPDF = () => {
    setModalPDF(false);
  };

  const onOpenModalUpload = (record) => {
    setItem(record);
    setModalUpload(true);
  };

  const onCloseModalUpload = () => {
    setModalUpload(false);
  };

  const onOpenModalCustomer = (record = null) => {
    setModalCus(true);
    setItem(record);
  };

  const onCloseModalCustomer = () => {
    setModalCus(false);
  };

  const dataTable = (items || []).map((i) => {
    const r = i;
    delete r.children;
    return r;
  });

  const handleSubmitSearch = (values) => {
    const { from_date, to_date, from_created_at, to_created_at } = values;
    const filterUpdate = {};
    if (from_date === null) {
      filterUpdate.from_depart_date = null;
      filterUpdate.to_depart_date = null;
    }
    if (from_created_at === null) {
      filterUpdate.from_created_at = null;
      filterUpdate.to_created_at = null;
    }
    if (
      (from_date ||
        from_date !== null ||
        from_created_at ||
        from_created_at !== null) &&
      (to_date || to_date !== null) &&
      !to_created_at
    ) {
      filterUpdate.from_depart_date = from_date;
      filterUpdate.from_created_at = from_created_at;
      filterUpdate.to_depart_date = to_date;
      filterUpdate.to_created_at = null;
    } else if (
      (from_date ||
        from_date !== null ||
        from_created_at ||
        from_created_at !== null) &&
      (to_created_at || to_created_at !== null) &&
      !to_date
    ) {
      filterUpdate.from_depart_date = from_date;
      filterUpdate.from_created_at = from_created_at;
      filterUpdate.to_depart_date = null;
      filterUpdate.to_created_at = to_created_at;
    } else if (
      (from_date ||
        from_date !== null ||
        from_created_at ||
        from_created_at !== null) &&
      (to_created_at || to_created_at !== null) &&
      (to_date || to_date !== null)
    ) {
      filterUpdate.from_depart_date = from_date;
      filterUpdate.from_created_at = from_created_at;
      filterUpdate.to_depart_date = to_date;
      filterUpdate.to_created_at = to_created_at;
    }
    setFilter((filter) => ({
      ...filter,
      ...filterUpdate,
    }));
    setWithExpiry(LocalStorageKeys.order_list, {
      filter: {
        ...filter,
        ...filterUpdate,
      },
    });
  };

  const onOpenPickupModal = (data) => {
    setItem(data);
    setPickupModal(true);
  };

  const onOpenDropOffModal = (data) => {
    setItem(data);
    setDropOffModal(true);
  };

  const onClosePickup = () => {
    setPickupModal(false);
  };

  const onCloseDropOff = () => {
    setDropOffModal(false);
  };

  const contentRef = useRef(null);
  const handleCopyText = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success('Copied to clipboard');
      })
      .catch((error) => {
        console.error('Failed to copy:', error);
        message.error('Failed to copy to clipboard');
      });
  };

  const handleAssign = (record) => {
    setItem(record);
    setAssignModal(true);
  };

  const handleCloseAssign = (record) => {
    setAssignModal(false);
  };

  const columns = [
    {
      title: <IntlMessages id="order.customer" />,
      key: 'customer.firstname',
      // sorter: true,
      dataIndex: 'customer.firstname',
      render: (text, record) => {
        return (
          <Space direction="vertical" size={4}>
            <Text
              onClick={() => onOpenModalCustomer(record?.customer)}
              style={{ cursor: 'pointer', color: '#1677ff' }}
            >
              {record?.customer?.fullname}
            </Text>

            {record?.customer?.email && (
              <>
                <Paragraph
                  style={{ maxWidth: '100px', marginBottom: '0' }}
                  ellipsis={{ rows: 1, expandable: false, symbol: 'more' }}
                >
                  <CopyOutlined
                    style={{
                      cursor: 'pointer',
                      color: '#08c',
                      marginRight: '5px',
                    }}
                    onClick={() => handleCopyText(record.customer.email)}
                  />
                  {record.customer.email}
                </Paragraph>
              </>
            )}
            {record?.customer?.mobile && <Text>{record.customer.mobile}</Text>}
            {/* {record?.customer?.company_shortname && (
              <Text>{record?.customer?.company_shortname}</Text>
            )} */}
          </Space>
        );
      },
    },
    {
      title: <IntlMessages id="global.order_id" />,
      key: 'order_no',
      // width: 100,
      dataIndex: 'order_no',
      render: (text, record, index) => {
        return (
          <Link to={`/app/orders/details/${record.id}`}>
            <Text type="success">{record.order_no}</Text>
          </Link>
        );
      },
    },
    {
      title: <IntlMessages id="global.services" />,
      key: 'option',
      dataIndex: 'option',
      render: (text, record) => {
        return (
          <Space direction="vertical" size={4}>
            <Paragraph
              style={{ maxWidth: '200px', marginBottom: '0' }}
              ellipsis={{ rows: 1, expandable: false, symbol: 'more' }}
              strong
            >
              {record?.option?.tour?.title}
            </Paragraph>

            <Text>
              {record?.option?.title}{' '}
              {record.seating > 1 ? `(x${record.seating})` : ''}
            </Text>
            {/* <Text>
              {record?.seating} {record?.option?.option_unit}
            </Text> */}
            {/* {record.pickup_time && (
              <Text>
                <Text strong>
                  <ClockCircleOutlined /> :
                </Text>{' '}
                {record.pickup_time}
              </Text>
            )} */}
            {/* {record.pickup_address || record.drop_off ? (
              <Space>
                {record.pickup_address && (
                  <Text>
                    <Paragraph
                      style={{ maxWidth: '200px', marginBottom: '0' }}
                      ellipsis={{ rows: 1, expandable: true, symbol: 'more' }}
                    >
                      <Text strong>
                        <EnvironmentOutlined /> :
                      </Text>{' '}
                      {record.pickup_address}
                    </Paragraph>
                  </Text>
                )}
                {record.drop_off && (
                  <>
                    ~
                    <Text>
                      <Paragraph
                        style={{ maxWidth: '200px', marginBottom: '0' }}
                        ellipsis={{
                          rows: 1,
                          expandable: true,
                          symbol: 'more',
                        }}
                      >
                        <Text strong>
                          <PushpinOutlined /> :
                        </Text>{' '}
                        {record.drop_off}
                      </Paragraph>
                    </Text>
                  </>
                )}
              </Space>
            ) : null} */}
            <Space size={2}>
              {!(record.pickup_time && record.pickup_address) && (
                <Button
                  type="primary"
                  size="small"
                  danger
                  onClick={() => onOpenPickupModal(record)}
                >
                  <IntlMessages id="global.add_pickup" />
                </Button>
              )}
              {record.pickup_time && record.pickup_address && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => onOpenPickupModal(record)}
                >
                  <IntlMessages id="global.edit_pickup" />
                </Button>
              )}
              {/* <Button type="primary" onClick={() => onOpenDropOffModal(record)}>
                <IntlMessages id="global.drop_off" />
              </Button> */}
            </Space>
            {/* {record?.roundtrip && (
              <Space size={4} align="start">
                <Text strong>
                  {record?.return_hop?.start_stop?.title} -{' '}
                  {record?.return_hop?.end_stop?.title}:
                </Text>
                <Space direction="vertical" size={4}>
                  {record?.return_hop?.cabins?.map((cabin, index) => (
                    <Space size={4} key={index}>
                      <Text strong>{cabin?.cabin?.title}</Text>
                      <Text>{cabin?.qty && `x${cabin?.qty}`}</Text>
                    </Space>
                  ))}
                </Space>
              </Space>
            )} */}
          </Space>
        );
      },
    },
    {
      title: <IntlMessages id="order.depart_date" />,
      key: 'date',
      // sorter: true,
      dataIndex: 'date',
      render: (text, record) => {
        return (
          <Space direction="vertical" size={4}>
            <Text>
              {convertToAnyTimezone(record.depart_date).format('DD/MM/YYYY')}
            </Text>
            <Text>
              {convertToAnyTimezone(record.depart_date).format('HH:mm')}
            </Text>
            {/* {record?.free_cancel_date && (
              <Text>
                {convertToAnyTimezone(record.free_cancel_date).format(
                  'DD/MM/YYYY HH:mm'
                )}
              </Text>
            )} */}
          </Space>
        );
      },
    },
    {
      title: <IntlMessages id="order.pax" />,
      key: 'qty',
      // sorter: true,
      dataIndex: 'qty',
      render: (text, record) => {
        return (
          //<IntlMessages id={`group.${record.description}`} />;
          <Button
            type="link"
            size="small"
            onClick={() => onOpenModalPax(record)}
            shape="round"
            // icon={<EditOutlined />}
          >
            {record.qty}
          </Button>
        );
      },
    },
    {
      title: <IntlMessages id="global.total" />,
      key: 'total',
      sorter: true,
      dataIndex: 'total',
      render: (text, record) => {
        return (
          <Space direction="vertical">
            <Currency value={record.total}></Currency>
          </Space>
        );
      },
    },
    // {
    //   title: <IntlMessages id="global.supplier_total" />,
    //   key: 'supplier_total',
    //   sorter: true,
    //   width: 80,
    //   dataIndex: 'supplier_total',
    //   render: (text, record) => {
    //     return (
    //       <Space direction="vertical">
    //         {record.supplier_total && (
    //           <Currency
    //             style={{ color: '#1777ff' }}
    //             value={record.supplier_total}></Currency>
    //         )}
    //       </Space>
    //     );
    //   },
    // },
    {
      title: <IntlMessages id="order.order_status" />,
      key: 'order_status',
      // sorter: true,
      width: 80,
      dataIndex: 'order_status',
      render: (text, record) => {
        return (
          <>
            {record.order_status === 'pending' ? (
              <Space direction="vertical" size={4}>
                <Status type="order" status={record.order_status} />
                <Button
                  type="default"
                  size="small"
                  style={{ fontSize: '12px' }}
                  onClick={() =>
                    handleUpdateStatus(record, OrderStatus.confirmed.status)
                  }
                >
                  <IntlMessages id="global.confirm" />
                </Button>
              </Space>
            ) : record.order_status === 'confirmed' ? (
              <>
                <Status type="order" status={record.order_status} />
              </>
            ) : (
              <Status type="order" status={record.order_status} />
            )}
          </>
        );
      },
    },
    {
      title: <IntlMessages id="order.pay_status" />,
      key: 'pay_status',
      // sorter: true,
      width: 80,
      dataIndex: 'pay_status',
      render: (text, record) => {
        // return record.pay_status === 'pending' ||
        //   record.pay_status === 'confirmed' ? (
        //   <Tag color="#2db7f5" bordered={false}>
        //     {record.pay_status}
        //   </Tag>
        // ) : record.pay_status === 'paid' ? (
        //   <Tag color="#87d068">{record.pay_status}</Tag>
        // ) : (
        //   <Tag color="error">{record.pay_status}</Tag>
        // );
        return <Status type="pay" status={record.pay_status} />;
      },
    },
    {
      title: <IntlMessages id="order.supplier_status" />,
      key: 'supplier_status',
      // sorter: true,
      width: 80,
      dataIndex: 'supplier_status',
      render: (text, record) => {
        // return record.pay_status === 'pending' ||
        //   record.pay_status === 'confirmed' ? (
        //   <Tag color="#2db7f5" bordered={false}>
        //     {record.pay_status}
        //   </Tag>
        // ) : record.pay_status === 'paid' ? (
        //   <Tag color="#87d068">{record.pay_status}</Tag>
        // ) : (
        //   <Tag color="error">{record.pay_status}</Tag>
        // );
        return (
          <Space direction="vertical">
            <Status type="supplier" status={record.supplier_status} />
            <Button
              size="small"
              type="primary"
              shape="round"
              onClick={() => onOpenModalUpload(record)}
            >
              <IntlMessages id="global.edit" />
            </Button>
          </Space>
        );
      },
    },
    {
      title: <IntlMessages id="global.operator" />,
      key: 'operator_id',

      dataIndex: 'operator_id',
      render: (text, record) => (
        <Space direction="vertical" size={2}>
          {record.operator && (
            <>
              {' '}
              <Text>{record.operator?.title}</Text>
              <Text copyable>{record.operator?.email}</Text>
              {record.operator?.phone && (
                <Text copyable={{ text: record.operator?.phone }}>
                  {record.operator?.phone} |{' '}
                  <a
                    href={`https://zalo.me/${record.operator?.phone}`}
                    target="_blank"
                  >
                    <Image
                      style={{
                        width: '20px',
                      }}
                      preview={false}
                      src={zalo_icon}
                    />
                  </a>
                </Text>
              )}
            </>
          )}
          <Button
            type="primary"
            shape="round"
            size="small"
            onClick={() => handleAssign(record)}
          >
            <IntlMessages id="global.assign" />
          </Button>
        </Space>
      ),
    },
    {
      title: <IntlMessages id="global.created_at" />,
      key: 'created_at',
      // sorter: true,

      dataIndex: 'created_at',
      render: (text, record) => {
        return (
          <Space direction="vertical" size={2}>
            {/* <Text>{record.created_by}</Text> */}
            <Text>{dayjs(record.created_at).format('DD/MM/YYYY')}</Text>
            <Text>{dayjs(record.created_at).format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    {
      title: '',
      width: 100,
      align: true,
      fixed: 'right',
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => onOpenEditModal(record)}
              shape="round"
              disabled={
                record.is_expired ||
                record?.order_status === OrderStatus.cancelled.status ||
                record?.pay_status === PayStatus.paid.status ||
                record?.pay_status === PayStatus.deposited.status
              }>
              <IntlMessages id="global.edit" />
            </Button> */}

            <Button
              size="small"
              onClick={() => onOpenModalPDF(record)}
              icon={<DownloadOutlined></DownloadOutlined>}
            ></Button>

            {/* {record.order_status === orderStatus.pending && (
              <Button
                type="primary"
                size="small"
                onClick={() =>
                  handleUpdateStatus(record, orderStatus.cancelled)
                }
                danger
                shape="round"
              >
                <IntlMessages id="global.cancel" />
              </Button>
            )} */}
          </Space>
        );
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Row justify="space-between">
          <Col>
            <PageTitle title={<IntlMessages id="global.orders" />} />
          </Col>

          <Col>
            <ActionBar
              onDelete={() => onDelete(selectedRowKeys)}
              isShowAddButton={false}
              //onAdd={onOpenModal}
              onRefresh={() => onReload()}
              isShowPublishButtons={false}
              isShowCopyButton={false}
              isShowDeleteButton={false}
              isDisabled={!hasSelected}
            ></ActionBar>
          </Col>
        </Row>

        <FilterBar
          onFilter={onFilter}
          data={[
            {
              name: 'operator_id',
              data: operators,
              placeholder: <IntlMessages id="global.select_operators" />,
            },
            {
              name: 'tour_id',
              data: tours,
              placeholder: <IntlMessages id="global.select_tours" />,
            },
            {
              name: 'customer_id',
              data: customers,
              placeholder: <IntlMessages id="global.select_customer" />,
            },
            {
              name: 'order_status',
              data: orderStatusFilter,
              placeholder: <IntlMessages id="global.order_status" />,
            },
            {
              name: 'pay_status',
              data: payStatusFilter,
              placeholder: <IntlMessages id="global.pay_status" />,
            },
          ]}
        />

        <FormSearch handleSubmitSearch={handleSubmitSearch} />

        <Table
          tableLayout="auto"
          columns={columns}
          dataSource={dataTable}
          onChange={onChangeTable}
          rowKey="id"
          // rowSelection={rowSelection}
          size="small"
          loading={loading}
          scroll={{
            x: 'max-content',
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
        />
      </Space>
      {modalPax ? (
        <FormPax
          open={modalPax}
          onClose={onCloseModalPax}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {modalPDF ? (
        <FormPdf
          open={modalPDF}
          onClose={onCloseModalPDF}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {modalCus ? (
        <CustomerDetails
          open={modalCus}
          onClose={onCloseModalCustomer}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {editModal ? (
        <EditOrderForm
          open={editModal}
          onClose={onCloseEditModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {pickupModal && (
        <PickupModal
          open={pickupModal}
          currentData={item}
          onClose={() => onClosePickup()}
          onReload={onReload}
        />
      )}
      {dropOffModal && (
        <DropOffModal
          open={dropOffModal}
          currentData={item}
          onClose={() => onCloseDropOff()}
          onReload={onReload}
        />
      )}
      {assignModal && (
        <AssignOperatorModal
          open={assignModal}
          currentData={item}
          onClose={() => handleCloseAssign()}
          onReload={onReload}
        />
      )}

      {modalUpload && (
        <ModalSupplierStatus
          open={modalUpload}
          currentData={item}
          onClose={() => onCloseModalUpload()}
          onReload={onReload}
        />
      )}
    </Card>
  );
}

export default Orders;
